import { authInstance, publicInstance } from "apis";
import { AxiosError } from "axios";
import { useMutation } from "react-query";
import { useNavigate } from "react-router-dom";
import { useSetRecoilState } from "recoil";
import authAtom from "stores/auth";
import ApiError from "types/ApiError";

interface Params {
  userName: string;
  password: string;
}

interface Data {
  token: string;
}

interface Props {
  onSuccess: () => void;
  onError: (error?: string | string[]) => void;
}

const useLogin = ({ onError, onSuccess }: Props) => {
  const navigate = useNavigate();
  const setAuth = useSetRecoilState(authAtom);

  const fetcher = async (params: Params) => {
    const { data } = await publicInstance.post("/user/logIn", params);
    return data;
  };

  const { mutate } = useMutation<Data, AxiosError<ApiError>, Params>(fetcher, {
    onSuccess: ({ token }) => {
      localStorage.setItem("TOKEN", token);
      authInstance.defaults.headers.common["Authorization"] = `Bearer ${token}`;
      setAuth({
        isLogin: true,
        type: "company",
      });
      onSuccess();
      navigate("/");
    },
    onError: (error) => {
      onError(error.response?.data.message);
    },
  });

  return mutate;
};

export default useLogin;
